<template>
  <div>
    <OwnerAdd />
  </div>
</template>

<script>
import OwnerAdd from "./OwnerAdd.vue";

export default {
  components: {
    OwnerAdd,
  },

  data() {
    return {};
  },
};
</script>
